import React, { useEffect, useState, useRef } from "react";

export const Team = (props) => {
  const [isVisible, setIsVisible] = useState(false);
  const appRef = useRef(null);

  useEffect(() => {
    const currentApp = appRef.current;
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setIsVisible(true);
          if (currentApp) observer.unobserve(currentApp);
        }
      },
      { threshold: 0.1 }
    );

    if (currentApp) {
      observer.observe(currentApp);
    }

    return () => {
      if (currentApp) {
        observer.unobserve(currentApp);
      }
    };
  }, []);

  return (
    <div id="app" className={isVisible ? "is-visible" : ""} ref={appRef}>
      <div className="container">
        <div className="row d-flex">
          <div className="col-xs-12 col-md-6">
            <img src="img/arco-app.png" className="img-responsive" alt="" />
          </div>
          <div className="col-xs-12 col-md-6">
            <div className="about-text">
              <h2>Conta Segura e Investimentos</h2>
              <p>{props.data ? props.data.paragraph : "loading..."}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};